module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "playerbar"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullScreen),
      expression: "!fullScreen"
    }],
    staticClass: "mini-player",
    on: {
      "click": _vm.open
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    class: _vm.cdCls,
    attrs: {
      "alt": "",
      "src": "//p0.ifengimg.com/pmop/2017/1106/93B9FC60B54079B13D734CADA5E7F7414E7FB626_size43_w468_h563.jpeg",
      "width": "40",
      "height": "40"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "control"
  }), _vm._v(" "), _c('div', {
    staticClass: "control",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showPlayList($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-playlist"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('h2', {
    staticClass: "name"
  }, [_vm._v("他为华人在国外赢了个重要官司 西方媒体却不敢报")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("test1")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d052f55"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/playerbar.vue
// module id = 318
// module chunks = 8